import { getItemDef } from "./items";
import { makePlanet } from "./planet";
import type { EntityId, SpaceItem, World } from "./types";

export function createWorld(): World {
  return {
    tick: 0,
    time: 0,
    planet: makePlanet(),
    ships: new Map(),
    crew: new Map(),
    projectiles: new Map(),
    items: new Map(),
    asteroids: [],
    events: [],
    beams: [],
    plumeSegments: [],
    sparks: [],
    nextId: 1,
  };
}

export function spawnItem(
  world: World,
  defId: string,
  spawn: {
    x: number; y: number;
    vx?: number; vy?: number;
    rot?: number; angVel?: number;
    quality?: number;
    tempK?: number;
  },
): SpaceItem {
  const def = getItemDef(defId);
  const id: EntityId = world.nextId++;
  const item: SpaceItem = {
    id,
    defId,
    pos: { x: spawn.x, y: spawn.y },
    vel: { x: spawn.vx ?? 0, y: spawn.vy ?? 0 },
    rot: spawn.rot ?? 0,
    angVel: spawn.angVel ?? 0,
    hp: def.stats.hp,
    quality: spawn.quality ?? 1,
    tempK: spawn.tempK ?? def.stats.temperature,
  };
  world.items.set(id, item);
  return item;
}
